import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection, importProvidersFrom } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideRouter } from '@angular/router';

import { provideLoadingBar } from '@ngx-loading-bar/core';
import { provideLoadingBarRouter } from '@ngx-loading-bar/router';
import { provideLoadingBarInterceptor } from '@ngx-loading-bar/http-client';

import { provideTranslateService, provideTranslateLoader } from "@ngx-translate/core";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";

import { environment } from "environments/environment";
import { routes } from './app.routes';

import { provideIonicStorage } from './providers/ionic-storage.provider';

export const appConfig: ApplicationConfig = {
    providers: [
        provideLoadingBar({ latencyThreshold: 100 }),
        provideLoadingBarRouter(),
        provideLoadingBarInterceptor(),

        provideHttpClient( withInterceptorsFromDi() ),
        
        provideBrowserGlobalErrorListeners(),
        provideZoneChangeDetection({ eventCoalescing: true }),

        provideHttpClient(),
        provideTranslateService({
            loader: provideTranslateHttpLoader({
                suffix: `.json?v=${Date.now()}`,
                prefix: '/assets/i18n/',
            }),

            fallbackLang: 'es',
            lang: 'es'
        }),

        provideRouter(routes),

        provideIonicStorage,
    ]
};